import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function ImgConvertPrivacyPolicyEn() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # Privacy Policy

"Image Format Converter App" (hereinafter referred to as "this app") respects users' privacy and takes maximum care to protect personal information. This app does not collect users' personal information and takes measures to protect users' data. This Privacy Policy (hereinafter referred to as "this Policy") sets forth the handling of information in this app.

## Article 1 (Collection and Management Policy of Personal Information)

This app does not collect any personal information (such as name, address, phone number, etc.) from users. All functions within the app are designed on the premise that no personal information will be collected. Also, to protect users' privacy, we do not collect or store any information that can identify individuals in accordance with personal information protection laws.

## Article 2 (Handling of Image Data)

In this app, all image data that users convert is processed only within the user's device and is not transmitted to external servers. Image conversion processing is performed entirely locally, and both original and converted image data are stored only on the device. We have no access to users' image data.

## Article 3 (Ad Delivery)

This app delivers advertisements through Google AdMob. During the ad delivery process, data may be automatically collected by Google's system for ad delivery optimization, but this data is managed according to Google's privacy policy. This app does not retain any personal information related to ad delivery. For details, please refer to Google's privacy policy.

## Article 4 (Changes to Privacy Policy)

This app may review the contents of this Policy from time to time and change this Policy in accordance with amendments to laws and changes in app functions to improve user privacy protection. When changes are made, users will be notified by posting the latest privacy policy within this app, and it will take effect simultaneously with the posting. Users are requested to check this Policy periodically.

## Article 5 (Contact Information)

If you have any questions or concerns about this Policy, please contact us at the following address:

Email: linappworks@gmail.com
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default ImgConvertPrivacyPolicyEn; 